// extracted by mini-css-extract-plugin
export default {"tableStyles":"AnomaliesTable_tableStyles__eFHLf"};